var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "19px",
    viewBox: "0 0 30 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "server-location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expermentation-v02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-additional-details",
    transform: "translate(-28.000000, -674.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(16.000000, 648.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,13.48794 C30,16.38654 27.642,18.74394 24.75,18.74394 L4.116,18.74394 C1.848,18.74394 0,16.88994 0,14.61594 C0,12.43794 1.698,10.64994 3.84,10.50594 C3.93,7.40394 6.486,4.90194 9.612,4.89594 C10.812,1.94994 13.68,-6e-05 16.89,-6e-05 C21.228,-6e-05 24.756,3.52794 24.756,7.86594 C24.756,7.99794 24.756,8.11794 24.75,8.24394 C27.642,8.24394 30,10.59594 30,13.48794",
    id: "server-location"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerLocationIcon);
export default __webpack_public_path__ + "static/media/server-location-icon.ce6a74ed07cc154f5da3f2e6f6818d3a.svg";
export { ForwardRef as ReactComponent };